import React from 'react';
import BottomSheetContainer from "@sharedComponents/Bottomsheet/Bottomsheet";
import {ThemedText, ThemedView} from '@app/theme';
import Button from "@sharedComponents/Button/Button";
import SystemErrorIcon from '../../../../assets/Icons/SystemErrorIcon';
import SystemWarning from '../../../../assets/Icons/SystemWarning';

interface ErrorCardProps {
  visible: boolean;
  onClose: () => void;
  failedTitle: string;
  failedSubTitle: string;
  colors: any;
  showCTA?: boolean;
  ctaAction?: () => void;
}

const ErrorCard: React.FC<ErrorCardProps> = ({ visible, onClose, failedTitle, failedSubTitle, colors, showCTA, ctaAction}) => (
  <BottomSheetContainer
    isVisible={visible}
    close={onClose}
    onClose={onClose}
    dragComponent={undefined}
    closeOnBackdropPress={true}
    borderTopRightRadius={10}
    borderTopLeftRadius={10}
    containerStyle={{backgroundColor: '#fefefe'}}
  >
    <ThemedView alignItems={"center"} padding={"lg"}>
      <SystemWarning/>
      <ThemedText mt={"2xl"} variant={"h5s"} mb={"sm"} textAlign={"center"}>
        {failedTitle || "Verification failed"}
      </ThemedText>
      <ThemedView borderRadius={"sm"} padding={"md"} backgroundColor={"bg-fill-warning"} style={{width: "100%"}} mb={"2xl"}>
        <ThemedText variant={"b3r"} textAlign={"center"}>
          {failedSubTitle}
        </ThemedText>
      </ThemedView>
      {showCTA &&<Button
        label="Edit details"
        type="SOLID"
        size='MD'
        disabled={false}
        handlePress={ctaAction}
        bg={'bg-action-primary'}
        textColor={colors['text-primary']}
      />
      }
    </ThemedView>
  </BottomSheetContainer>
);

export default ErrorCard;